import styled from 'styled-components'
import { spacing } from 'syf-component-library/defaultTheme'
import { Textfield } from 'syf-component-library/ui/atoms'

export const TextFieldCustom = styled(Textfield)`
  & .helper-error-alignment {
    // to align the icon with the text in the error/helper section of the input
    line-height: ${spacing.base}px;
  }
`
